
import Checkbox from './Checkbox';
import CheckboxGroup from './CheckboxGroup';

Checkbox.Group = CheckboxGroup;

export default Checkbox;



// WEBPACK FOOTER //
// ./components/Checkbox/index.js